import { useFirebase } from '../../../contexts/FirebaseContext';
import { AppShell } from '../../components/AppShell/AppShell';
import { Footer } from '../../components/Footer/Footer';
import { PageHeader } from '../../components/PageHeader/PageHeader';
import { FullscreenLoader } from '../../components/FullscreenLoader/FullscreenLoader';
import { InfiniteScrollableList } from '../../components/InfiniteScrollableList/InfiniteScrollableList';
import { Title } from '../../components/Title/Title';
import { useTranslation } from 'react-i18next';
import { Redirect, useHistory, useParams } from 'react-router-dom';
import styles from './TootorDetail.module.scss';

const TootorDetailComponent = () => {
  const { authors, videos } = useFirebase();
  const { idTootor } = useParams<{ idTootor: string }>();
  const history = useHistory();
  const { t } = useTranslation();

  if (!authors?.length) return <FullscreenLoader />;

  const author = authors.find((item) => item.id === idTootor);
  if (!author) return <Redirect to="/tootors" />;

  const authorVideos = videos.filter((video) => video.author?.id === author.id);

  return (
    <AppShell className={styles.shell}>
      <div className={styles.page}>
        <Title>{author.name}</Title>

        <PageHeader
          title={t('tootors.labels.iNostriToot')}
        />

        <article className={styles.profile}>
          <div className={styles.identity}>
            <div className={styles.photo}><img src={author.photo} alt={author.name} /></div>
            <div>
              <h2>{author.name}</h2>
              {!!author.description?.trim() && <p><strong>{t('tootors.labels.specializzazione')}:</strong> {author.description}</p>}
              <p><strong>{t('tootors.labels.videoInPiattaforma')}:</strong> {authorVideos.length}</p>
            </div>
          </div>

          {!!author.bio?.trim() && (
            <section>
              <h3>{t('tootors.labels.carriera')}</h3>
              <p>{author.bio}</p>
            </section>
          )}

          <section>
            {!!authorVideos.length && <InfiniteScrollableList className={styles.authorVideosList} title={t('tootors.labels.alcuniCasi')} elements={authorVideos} />}
          </section>

          <footer className={styles.actions}>
            <button type="button" className="tootor-button tootor-button--basic" onClick={() => history.push('/tootors')}>‹ {t('tootors.labels.tornaAiTootor')}</button>
            <div>
                <button type="button" className="tootor-button tootor-button--basic" onClick={() => history.push(`/search?q=${encodeURIComponent(author.name)}`)}>{t('tootors.labels.guardaAltriCasi')}</button>
            </div>
          </footer>
        </article>

        <Footer />
      </div>
    </AppShell>
  );
};

export default TootorDetailComponent;
